import { render } from "./Programming.vue?vue&type=template&id=12c05724&scoped=true"
const script = {}

import "./Programming.vue?vue&type=style&index=0&id=12c05724&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-12c05724"

export default script